module.exports = __webpack_public_path__ + "img/TBA_Logo.7751ad13.png";